import React, { useState } from 'react';
import { View, Text } from 'react-native';
import { useQuery } from '@apollo/client';
import { HMSRoomProvider } from "@100mslive/react-sdk";

import DataState from 'app/src/components/DataState';
import { useParams } from 'app/src/utils/routing';
import * as colors from 'app/src/styles/colors';
import { dollars } from 'app/src/utils/stringHelpers';
import Header from '../BiddingNew/Header';
import BidHistory from '../BiddingNew/BidHistory';

import {
  ContainerWithFlash,
  Container,
  BorderedContainer,
  Column,
  Title,
  Subtitle,
  NoticeContainer,
  NoticeText,
  Split,
} from './elements';
import NewStream from './NewStream';
import Flash from './Flash';
import CurrentSaleAssets from './CurrentSaleAssets';
import SaleAssets from './SaleAssets';
import SaleAssetDetail from './SaleAssetDetail';
import Visit from './Visit';
import { SALE } from '../BiddingNew/queries';
import useSubscriptions from '../BiddingNew/useSubscriptions';

const Auctioneer = () => {
  const { id } = useParams();
  useSubscriptions({ id });

  const [recordingConnected, setRecordingConnected] = useState(false);

  const { data } = useQuery(SALE, { variables: { id } });

  if (!data) { return <DataState.Loading />; }

  const highBid = data.sale.biddingSaleAsset &&
    data.sale.biddingSaleAsset.bids[data.sale.biddingSaleAsset.bids.length - 1];

  return (
    <div style={{width: '100%', marginBottom: '0px'}}>
      <Header
        sale={data.sale}
        style={{marginBottom: '50px', zIndex: 100}}
      />
      <ContainerWithFlash>
        <Flash sale={data.sale} style={{marginTop: '50px'}} />
        <Container style={{justifyContent: 'center'}}>
          <Column style={{maxWidth: '50%'}}>
            <BorderedContainer style={{overflow: 'auto'}}>
              <Title>Auctioneer</Title>

              <View style={{flexDirection: 'row', gap: 20}}>
                {data.sale.bidding ? (
                  <Subtitle>Sale is Active</Subtitle>
                ) : (
                  <Subtitle style={{color: colors.elRed}}>
                    Sale is Not Active
                  </Subtitle>
                )}

                <Subtitle>
                  {data.sale.lotsRemainingLabel}
                  {' | '}
                  {data.sale.activeBidderCount} Bidders Online
                </Subtitle>
              </View>

              <HMSRoomProvider>
                <Visit saleId={data.sale.id} page="Auctioneer" />

                <NewStream
                  userName="Auctioneer"
                  roomCode={data.sale.auctioneerRoomCode}
                  sale={data.sale}
                  activeStream={data.sale.activeStream}
                  producer
                  setIsConnected={setRecordingConnected}
                />
                <Split />
              </HMSRoomProvider>

              {recordingConnected ? (
                <></>
              ) : (
                <HMSRoomProvider>
                  <NewStream
                    userName="Auctioneer - Viewer"
                    roomCode={data.sale.viewerRoomCode}
                    sale={data.sale}
                    activeStream={data.sale.activeStream}
                    page="Auctioneer"
                  />
                  <Split />
                </HMSRoomProvider>
              )}

              <NoticeContainer
                key={data.sale.biddingNotice}
                notice={data.sale.biddingNotice}
              >
                <NoticeText>{data.sale.biddingNotice || ' '}</NoticeText>
              </NoticeContainer>
              <Split />

              {data.sale.biddingSaleAsset && (
                <BidHistory bids={data.sale.biddingSaleAsset.bids} />
              )}
            </BorderedContainer>
          </Column>
          {/* <Column>
            {data.sale.biddingSaleAsset ? (
              <SaleAssetDetail
                saleAsset={data.sale.biddingSaleAsset}
                groupSaleAssets={data.sale.bidGroupSaleAssets}
              />
            ) : (
              <BorderedContainer>
                <Title>No Assets Current Bidding</Title>
              </BorderedContainer>
            )}
          </Column>
          <Column>
            <BorderedContainer
              style={{
                backgroundColor: highBid?.backgroundColor,
                gap: 20,
                alignItems: 'center',
              }}
            >
              {highBid && (
                <>
                  <Text
                    style={{
                      color: highBid?.foregroundColor,
                      fontSize: 110,
                      fontWeight: 600,
                    }}
                  >
                    {dollars(highBid.price)}
                  </Text>
                  {highBid.buyer ? (
                    <>
                      <Text
                        style={{
                          color: highBid?.foregroundColor,
                          fontSize: 50,
                          fontWeight: 600,
                        }}
                      >
                        by {highBid.paddleNumber}
                      </Text>
                      <Text
                        style={{
                          color: highBid?.foregroundColor,
                          fontSize: 50,
                          fontWeight: 600,
                        }}
                      >
                        {highBid.buyer.cityState}
                      </Text>
                    </>
                  ) : (
                    <Text
                      style={{
                        fontSize: 50,
                        fontWeight: 600,
                      }}
                    >
                      by Floor
                    </Text>
                  )}
                </>
              )}
            </BorderedContainer>
          </Column> */}
        </Container>
      </ContainerWithFlash>
    </div>
  );
};

  export default Auctioneer;
